import React, { useEffect } from "react";
import dynamic from "next/dynamic";
import { useSelector, useDispatch } from "react-redux";
import { GridColumn } from "emotion-flex-grid";
import { getRecipesData, setSavedCollections, setSavedRecipes } from "../../../store/recipesReducer/recipesActions";
import { clearSearch } from "../../../store/recipesReducer";
import { isUserBuyer, getOwner } from "../../../store/userReducer/userSelectors";
import { pagesName } from "../../../variables/recipesVariables";
import HeadTitle from "components/HeadTitle";
import Menu from "components/Menu";
import { getCollectionsSorting, getRecipesSorting } from "../../../store/recipesReducer/recipesSelectors";
import { isLibraryShowPurchasedRecipes } from "../../../store/libraryReducer";

import { Container, Row, Content, Spinner } from "styles/App.styled";
import { useRouter } from "next/router";
const FoodieProfile = dynamic(() => import("components/ProfilePage"), { loading: () => <Spinner /> });
const CreatorProfile = dynamic(() => import("components/ProfilePage/Creator"), { loading: () => <Spinner /> });

const LibraryComponent = () => {
  const currentUser = useSelector(getOwner);
  const recipesSorting = useSelector(getRecipesSorting);
  const collectionsSorting = useSelector(getCollectionsSorting);
  const isPurchasedRecipes = useSelector(isLibraryShowPurchasedRecipes);
  const router = useRouter();
  const isBuyer = useSelector(isUserBuyer);
  const dispatch = useDispatch();
  const pageName = pagesName.library;

  const clearQuery = () => {
    const params = new URLSearchParams(router.query);
    params.delete("page");
    const queryString = params.toString();
    const path = `${router.pathname}${queryString ? `?${queryString}` : ""}`;
    router.push(path, "", { scroll: false });
  };

  const handleTabChange = () => {
    clearQuery();
    dispatch(getRecipesData({ pageName }));
  };

  useEffect(() => {
    dispatch(clearSearch());
    dispatch(getRecipesData({ pageName }));
  }, [isPurchasedRecipes]);

  useEffect(() => {
    if (recipesSorting.type && recipesSorting.value) {
      dispatch(setSavedRecipes());
    }
  }, [recipesSorting.type, recipesSorting.value]);

  useEffect(() => {
    if (collectionsSorting.type && collectionsSorting.value) {
      dispatch(setSavedCollections());
    }
  }, [collectionsSorting.type, collectionsSorting.value]);

  return (
    <>
      <HeadTitle title="Foody | Library" />
      <Container>
        <GridColumn pt={["xl1"]} pb={["xl2", "xxl2"]}>
          <Row>
            <Menu />
            <Content>
              {isBuyer ? (
                <FoodieProfile user={currentUser} isOwner page={pageName} setActive={handleTabChange} />
              ) : (
                <CreatorProfile user={currentUser} isOwner page={pageName} setActive={handleTabChange} />
              )}
            </Content>
          </Row>
        </GridColumn>
      </Container>
    </>
  );
};

export default LibraryComponent;
